import { useEffect } from 'react';
import useLocalStorage from './useLocalStorage';
import { DEFAULT_THEME } from '../config/theme';

const useTheme = () => {
  const [mainColor, setMainColor] = useLocalStorage(
    DEFAULT_THEME.storageKey,
    DEFAULT_THEME.primaryColor
  );

  useEffect(() => {
    document.documentElement.style.setProperty('--main-color', mainColor);
  }, [mainColor]);

  const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const changeColor = (newColor) => {
    const color = newColor || getRandomColor();
    setMainColor(color);
  };

  const resetColor = () => {
    setMainColor(DEFAULT_THEME.primaryColor);
  };

  return {
    mainColor,
    changeColor,
    resetColor,
    setColor: setMainColor
  };
};

export default useTheme;
